import { render, staticRenderFns } from "./campaignImages.vue?vue&type=template&id=25156a20&scoped=true&"
import script from "./campaignImages.vue?vue&type=script&lang=js&"
export * from "./campaignImages.vue?vue&type=script&lang=js&"
import style0 from "./campaignImages.vue?vue&type=style&index=0&id=25156a20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25156a20",
  null
  
)

export default component.exports